export const DEFAULT_DYNAMIC_CAROUSEL_COLUMN_SPAN = 4;
